import axios from "axios";
import store from "../../store";
import { Message } from "element-ui";
import VueCookie from "vue-cookie";
import router from "../../router";

if (window.location.search.split("?id=")[1]) {
  axios.defaults.headers.common["id"] = window.location.search.split("?id=")[1];
}

let request = [];
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
axios.interceptors.request.use(
  config => {
    if (config.url.indexOf("messages") != -1 && config.method == "get") {
      return config;
    }
    store.dispatch("openLoad", true);
    request.push(config.url.split("?")[0]);

    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(
  res => {
    request.splice(request.indexOf(res.config.url.split("?")[0]), 1);
    if (request.length == 0) {
      store.dispatch("openLoad", false);
    }
    if (res.data.code == 10001) {
      if (store.state.selfInfo) {
        // window.Echo.leave(`App.User.${store.state.selfInfo.id}`);
      }
      Message.error(res.data.message);
      axios.defaults.headers.common.Authorization = "";
      VueCookie.delete("token");
      if (router.history.current.name != "login") {
        router.push("/login");
      }
      return res;
    }
    if (res.data.code != 0) {
      Message.error(res.data.message);
      return res;
    }
    return res;
  },
  err => {
    request.splice(request.indexOf(err.config.url.split("?")[0]), 1);
    if (request.length == 0) {
      store.dispatch("openLoad", false);
    }
    if (err.response.status == 500) {
      Message({
        showClose: true,
        message: "很抱歉，功能异常目前维护中。",
        type: "error"
      });
    }
    if (err.response.status == 503) {
      location.href = process.env.VUE_APP_MAINTENACE;
      return;
    }
    return { data: { message: "Error" }, code: 111 };
  }
);

axios.defaults.headers.common.Authorization =
  "Bearer " + VueCookie.get("token");
